// extracted by mini-css-extract-plugin
export default {"Action":"Action_Action__CZzrU"};